import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Container } from "react-bootstrap";
import { ArrowRight } from "lucide-react";
import { successStories } from "./successStoriesData";
import CaseStudyModal from "./caseStudies/CaseStudyModal";

const SuccessStoryDetails = () => {
  const { slug } = useParams();
  const story = successStories.find((item) => item.slug === slug);
  const [showCaseStudyModal, setShowCaseStudyModal] = useState(false);

  if (!story) {
    return (
      <Container className="py-5 text-center">
        <h2>Case study not found</h2>
        <p>The selected success story could not be found.</p>
        <Link to="/success-stories" className="btn btn-dark">
          Back to Success Stories
        </Link>
      </Container>
    );
  }

  return (
    <>
      <style>{`
        .success-story-detail { font-family: 'Outfit', sans-serif; background: #fff; color: #0f172a; }
        .hero { padding: 80px 0 80px; text-align: center; background: #effdff; }
        .hero h1 { color:#0f172a; font-size: 2.6rem; font-weight: 800; }
        .hero p { color: #475569; font-size: 1.2rem; max-width: 900px; margin: 0 auto; }
        .content { padding: 40px 0; }
        .story-image { width: 100%; border-radius: 12px; object-fit: cover; max-height: 500px; }
        .story-details p { margin-bottom: 16px; }
        .actions { margin-top: 26px; display: flex; gap: 12px; flex-wrap: wrap; }
        .actions button, .actions a { padding: 10px 16px; font-weight: 700; border-radius: 10px; border: 0; color: #fff; text-decoration: none; cursor: pointer; }
        .actions .download { background: #ee0000; }
        .actions .back { color: #e00;
  background: #fff;
  border: 1px solid #e00; }
      `}</style>

      <div className="success-story-detail">
        <section className="hero">
          <Container>
            <h1>{story.title}</h1>
            <p>{story.excerpt}</p>
          </Container>
        </section>

        <Container className="content">
          <img src={story.image} alt={story.title} className="story-image" />
          <div className="story-details mt-4">
            {story.details.map((detail, idx) => (
              <p key={idx}>{detail}</p>
            ))}
          </div>

          <div className="actions">
            <button
              className="download"
              onClick={() => setShowCaseStudyModal(true)}
            >
              Download PDF
            </button>
            <Link to="/success-stories" className="back">
              <ArrowRight size={14} /> Back to Success Stories
            </Link>
          </div>
        </Container>

        <CaseStudyModal
          show={showCaseStudyModal}
          onHide={() => setShowCaseStudyModal(false)}
          caseStudyTitle={story.title}
          caseStudyPdfFile={story.pdfFile}
        />
      </div>
    </>
  );
};

export default SuccessStoryDetails;
